import { EditPolicyActivitiesController } from "../ts/rlAdmin.controllers.config";
import { RLActivityTreeListController } from "./activity-tree-list";
import * as Models from "../ts/rlAdmin.models";
import * as angular from "angular";

RLActivityTreeRow.$inject = ["$compile"];
export function RLActivityTreeRow($compile: ng.ICompileService) {
    var directive: ng.IDirective = {
        template: require("/assets/app/templates/activity-tree-row.html"),
        require: ["rlActivityTreeRow", "^rlActivityTreeList", "^ngController"],
        controller: RLActivityTreeRowController,
        controllerAs: "atrVM",
        bindToController: true,
        replace: true,
        scope: {
            activity: "=",
            depth: "="
        },
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controllers: [RLActivityTreeRowController, RLActivityTreeListController, EditPolicyActivitiesController]) => {

            controllers[0].listCtrl = controllers[1];
            controllers[0].treeCtrl = controllers[2];
            controllers[0].newDepth = controllers[0].depth + 1;
            if (controllers[0].activity != null && controllers[0].activity.childActivities.length > 0) {
                var templateElement = angular.element("<rl-activity-tree-list activities='atrVM.activity.childActivities' depth='atrVM.newDepth' parent-activity='atrVM.activity'></rl-activity-tree-list>");
                var compiled = $compile(templateElement);
                element.append(templateElement);
                compiled(scope);
            }
        }
    };
    return directive;
}


class RLActivityTreeRowController {

    static $inject = ["$scope"];

    treeCtrl: EditPolicyActivitiesController;
    listCtrl: RLActivityTreeListController;

    activity: Models.IAspNetSecurityActivity;
    depth: number;
    newDepth: number;
    iconClass: string;

    constructor($scope: ng.IScope) {

        this.iconClass = "fa-caret-right";

        if (this.activity.childActivities.length > 0) {
            this.iconClass = "fa-caret-down";
        } else {
            this.iconClass = "";
        }
    }

}
